<template>
  <a-modal
    v-model:visible="isVisible"
    :title="config.title"
    :ok-text="config.confirmText"
    :cancel-text="config.cancelText"
    :ok-button-props="{
      disabled: isConfirmDisabled || isLoading,
      loading: isLoading
    }"
    :cancel-button-props="{
      disabled: isLoading,
      loading: isLoading
    }"
    @ok="handleConfirm"
    @cancel="handleCancel"
    :wrapClassName="'modal-sm'"
    centered
  >
    <a-form layout="vertical">
      <a-form-item
        :label="config.commentLabel"
        :required="config.required"
        :validate-status="showError ? 'error' : ''"
        :help="showError ? config.errorMessage : ''"
      >
        <a-textarea
          v-model:value="commentText"
          :placeholder="config.placeholder"
          :required="config.required"
          :rows="config.rows || 4"
          :auto-size="{
            minRows: config.rows || 4,
            maxRows: config.maxRows || 8
          }"
          :disabled="isLoading"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue';

const defaultConfig = {
  title: '¿Estás seguro de realizar esta acción?',
  commentLabel: 'Comentario (opcional)',
  placeholder: 'Ingresa un comentario...',
  required: false,
  confirmText: 'Confirmar',
  cancelText: 'Cancelar',
  errorMessage: 'Este campo es obligatorio',
  initialComment: '',
  rows: 4,
  maxRows: 8
};

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  modalConfig: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['update:visible', 'confirm', 'cancel']);

const commentText = ref('');
const showError = ref(false);
const isLoading = ref(false);

const config = computed(() => ({
  ...defaultConfig,
  ...props.modalConfig
}));

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
});

const isConfirmDisabled = computed(() => {
  return config.value.required && !commentText.value.trim();
});

watch(
  () => props.visible,
  (newValue) => {
    if (newValue) {
      commentText.value = config.value.initialComment;
      showError.value = false;
    }
  }
);

const handleCancel = () => {
  emit('update:visible', false);
  emit('cancel');
};

const handleConfirm = async () => {
  if (config.value.required && !commentText.value.trim()) {
    showError.value = true;
    return;
  }

  showError.value = false;
  isLoading.value = true;

  try {
    emit('confirm', commentText.value.trim(), ({ close }) => {
      emit('update:visible', !close);
      isLoading.value = false;
    });
  } catch (error) {
    isLoading.value = false;
  }
};
</script>
